/**
 * Prodigi Print-on-Demand Configuration
 * SKU mappings for Eye of the Guide prints.
 *
 * Sizes:  Mini · Small · Medium · Large · Gallery
 * Frames: Black · White · Natural · Walnut
 * Mount:  Border · Full Bleed
 *
 * The configurator JS calls ProdigiConfig.getSku(size, frame, mount).
 * Update the SKUs below with the actual Prodigi catalogue identifiers
 * for each combination (40 SKUs total = 5 sizes × 4 frames × 2 mounts).
 *
 * If a SKU is missing, getSku() returns null and the cart line item
 * is added without a Prodigi reference — useful while you're still
 * filling in the catalogue. Add SKUs as you confirm them with Prodigi.
 */

window.ProdigiConfig = {
  apiEndpoint: 'https://api.prodigi.com/v4.0',

  /* Display data — used by the configurator UI to show dimensions etc. */
  sizes: {
    mini:    { name: 'Mini',    metric: '20 × 30 cm', imperial: '8 × 12"'   },
    small:   { name: 'Small',   metric: '30 × 45 cm', imperial: '12 × 18"'  },
    medium:  { name: 'Medium',  metric: '40 × 60 cm', imperial: '16 × 24"'  },
    large:   { name: 'Large',   metric: '50 × 75 cm', imperial: '20 × 30"'  },
    gallery: { name: 'Gallery', metric: '60 × 90 cm', imperial: '24 × 36"'  }
  },

  frames: {
    black:   { name: 'Black',   swatch: '#1a1a1a' },
    white:   { name: 'White',   swatch: '#ffffff' },
    natural: { name: 'Natural', swatch: '#c5a576' },
    walnut:  { name: 'Walnut',  swatch: '#5d3f2e' }
  },

  mounts: {
    border:       { name: 'Border'     },
    'full-bleed': { name: 'Full Bleed' }
  },

  /* SKU lookup table — keyed by `<size>__<frame>__<mount>`.
     Replace the placeholders with real Prodigi SKUs as the catalogue is
     finalised. Entries can be omitted; getSku() returns null for misses. */
  skus: {
    /* Mini */
    'mini__black__border':         'GLOBAL-CFR-MINI-BL-BO',
    'mini__black__full-bleed':     'GLOBAL-CFR-MINI-BL-FB',
    'mini__white__border':         'GLOBAL-CFR-MINI-WH-BO',
    'mini__white__full-bleed':     'GLOBAL-CFR-MINI-WH-FB',
    'mini__natural__border':       'GLOBAL-CFR-MINI-NA-BO',
    'mini__natural__full-bleed':   'GLOBAL-CFR-MINI-NA-FB',
    'mini__walnut__border':        'GLOBAL-CFR-MINI-WA-BO',
    'mini__walnut__full-bleed':    'GLOBAL-CFR-MINI-WA-FB',

    /* Small */
    'small__black__border':        'GLOBAL-CFR-SM-BL-BO',
    'small__black__full-bleed':    'GLOBAL-CFR-SM-BL-FB',
    'small__white__border':        'GLOBAL-CFR-SM-WH-BO',
    'small__white__full-bleed':    'GLOBAL-CFR-SM-WH-FB',
    'small__natural__border':      'GLOBAL-CFR-SM-NA-BO',
    'small__natural__full-bleed':  'GLOBAL-CFR-SM-NA-FB',
    'small__walnut__border':       'GLOBAL-CFR-SM-WA-BO',
    'small__walnut__full-bleed':   'GLOBAL-CFR-SM-WA-FB',

    /* Medium */
    'medium__black__border':       'GLOBAL-CFR-MD-BL-BO',
    'medium__black__full-bleed':   'GLOBAL-CFR-MD-BL-FB',
    'medium__white__border':       'GLOBAL-CFR-MD-WH-BO',
    'medium__white__full-bleed':   'GLOBAL-CFR-MD-WH-FB',
    'medium__natural__border':     'GLOBAL-CFR-MD-NA-BO',
    'medium__natural__full-bleed': 'GLOBAL-CFR-MD-NA-FB',
    'medium__walnut__border':      'GLOBAL-CFR-MD-WA-BO',
    'medium__walnut__full-bleed':  'GLOBAL-CFR-MD-WA-FB',

    /* Large */
    'large__black__border':        'GLOBAL-CFR-LG-BL-BO',
    'large__black__full-bleed':    'GLOBAL-CFR-LG-BL-FB',
    'large__white__border':        'GLOBAL-CFR-LG-WH-BO',
    'large__white__full-bleed':    'GLOBAL-CFR-LG-WH-FB',
    'large__natural__border':      'GLOBAL-CFR-LG-NA-BO',
    'large__natural__full-bleed':  'GLOBAL-CFR-LG-NA-FB',
    'large__walnut__border':       'GLOBAL-CFR-LG-WA-BO',
    'large__walnut__full-bleed':   'GLOBAL-CFR-LG-WA-FB',

    /* Gallery */
    'gallery__black__border':       'GLOBAL-CFR-GL-BL-BO',
    'gallery__black__full-bleed':   'GLOBAL-CFR-GL-BL-FB',
    'gallery__white__border':       'GLOBAL-CFR-GL-WH-BO',
    'gallery__white__full-bleed':   'GLOBAL-CFR-GL-WH-FB',
    'gallery__natural__border':     'GLOBAL-CFR-GL-NA-BO',
    'gallery__natural__full-bleed': 'GLOBAL-CFR-GL-NA-FB',
    'gallery__walnut__border':      'GLOBAL-CFR-GL-WA-BO',
    'gallery__walnut__full-bleed':  'GLOBAL-CFR-GL-WA-FB'
  },

  /* Resolve a SKU for a configuration. Returns null when the combo isn't
     in the catalogue yet — the cart line item then carries no Prodigi
     reference (you can backfill before fulfilment). */
  getSku: function (size, frame, mount) {
    if (!size || !frame || !mount) return null;
    if (frame === 'digital') return null;
    return this.skus[size + '__' + frame + '__' + mount] || null;
  }
};
